import type { NotificationCategory, NotificationSubcategory } from '../types/menu';

export interface NotificationCountSubcategory {
  name: string;
  value: string;
  count: number;
}

export interface NotificationCountCategory {
  id: number;
  name: string;
  value: string;
  count: number;
  subcategories: NotificationCountSubcategory[];
}

export interface NavNotificationCounts {
  byCategory: Partial<Record<NotificationCategory, number>>;
  bySubcategory: Partial<Record<NotificationSubcategory, number>>;
}

/** Builds category and subcategory count maps for `AppNavigation` notification badges. */
export function mapNotificationCounts(
  categories: NotificationCountCategory[]
): NavNotificationCounts {
  const byCategory: Partial<Record<NotificationCategory, number>> = {};
  const bySubcategory: Partial<Record<NotificationSubcategory, number>> = {};

  for (const category of categories) {
    const categoryKey = category.value as NotificationCategory;
    if (categoryKey) {
      byCategory[categoryKey] = category.count;
    }

    for (const sub of category.subcategories ?? []) {
      const subKey = sub.value as NotificationSubcategory;
      if (subKey) {
        bySubcategory[subKey] = sub.count;
      }
    }
  }

  return { byCategory, bySubcategory };
}

const NAV_BADGE_MAX = 99;

/** Caps nav badge labels so counts above 99 render as `99+`. */
export function formatNavBadgeCount(count: number): string {
  return count > NAV_BADGE_MAX ? `${NAV_BADGE_MAX}+` : String(count);
}

/** Offsets the submenu notification badge on the left border by label width. */
export function getSubmenuBadgeLeftClass(count: number): string {
  const label = formatNavBadgeCount(count);
  if (label.length === 1) return 'left-0';
  if (label.length === 2) return 'left-[-3px]';
  return 'left-[-6px]';
}
